<template>
    <div id="present">
        <div id="presentBg1" >
        <div class="introActivity">
            <section class="container" id="carplus">
                <div class="introFrame">
                    <img src="../assets/bow.png" alt="" class="bow">
                    <h3 class="titleBar">車體險加碼獎</h3>
                    <div class="mb-20 line-height-15">2026.10.1-2026.12.31 完成以下任務，<span class="blueText">雙週抽iPhone Duo</span>最高<span class="blueText">14</span>次*抽獎機會。<br>
                    <span class="subText ">*係以電動車投保資格計算(6期雙週抽共12次＋季末加碼抽2次)</span></div>
                    <div class="spFrame">
                        <div class="spBlueBox">
                            <h2>投保指定車體險</h2>
                            <div class="spPic">
                                <img src="../assets/sp01.svg" alt="sp01" />
                                <div>指定投保<div><span class="blueText">甲式、乙式、丙式</span>車體險</div></div>
                            </div>
                            <img src="../assets/icon_add.svg" alt="" class="spAdd">
                        </div>

                        <div class="spBox">
                            <h2>完成以下條件</h2>
                            <div class="spOrangeBox">
                                <div class="spPic">
                                    <img src="../assets/sp02.svg" alt="sp02" />
                                    <div class="blueText">登入會員</div>
                                </div>
                                <div class="spPic">
                                    <img src="../assets/sp03.svg" alt="sp03" />
                                    <div class="blueText">選擇電子保單</div>
                                    <div><span>投保完成後若更改為電子保單，將不納入抽獎資格計算</span></div>
                                </div>
                                <div class="spPic">
                                    <img src="../assets/sp04.svg" alt="sp04" />
                                    <div class="blueText">綁定LINE專屬服務</div>
                                    <div><span>至<a href="https://www.tmnewa.com.tw/ec/member/" >會員專區</a>啟用<br>綁定再拿</span><span class="blueText">LinePoint 10點</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img class="spImage" src="../assets/plus-top-img.svg" alt="" >
                    <div class="mt-20"><span>iPhone Duo 256G (顏色隨機)</span><br>
                    <span>共7支</span></div>
                </div>
            </section>
        </div>
        <section id="luckydraw">
            <p class="mt-30">詳細活動規則請見下方說明</p>
            <h2 class="title mt-40 mb-20">好禮三重抽</h2>
            <p class="mb-50">投保下方任一指定保險方案，即可獲得立即抽抽獎資格乙次，投保越多、獲得越多抽獎機會!</p>
            <ul class="list">
                <li :class="item.color" v-for="item in presentList" :key="item.id">
                    <div class="content">
                        <div class="q1Icon">
                            <img :src="item.Icon" alt="icon" />
                        </div>
                        <h3 class="my-20">{{ item.title }}</h3>
                        <p :class="item.textColor" v-html="item.text"></p>
                    </div>
                </li>
            </ul>
             </section>
            <div class="mt-50 mb-40">投保指定方案即可獲得大獎抽獎資格一次，使用電子保單還有機會抽電子保單獎!</div>
            <div>
                <div class="container">
                    <Carousel :wrapAround="true"  :autoplay="3500"  v-bind="settings" :breakpoints="breakpoints">
                        <Slide v-for="item in bigPrizeList" :key="item.id">
                            <div class="carousel__item prizeList">
                                <div class="prize">
                                    <div class="prizeTag">{{ item.priceTag }}</div>
                                    <div class="prizePic">
                                        <img :src="item.priceImg" alt="">
                                    </div>
                                    <div class="prizeText">
                                        <p>{{ item.text1 }}</p>
                                        <P>{{ item.text2 }}</P>
                                        <p class="small" v-html="item.time"></p>
                                        <p class="small" v-html="item.count"></p>
                                    </div>
                                </div>
                            </div>
                        </Slide>
                        <template #addons>
                            <pagination />
                        </template>
                    </Carousel>
                </div>
            </div>
        </div>
        <div id="presentBg2">
            <section id="luckydrawnow">
            <h2 class="title mt-50 mb-20">立即抽</h2>
            <p class="text mb-40">好禮立即抽!獎品立即拿! 高達四千多個獎品等你來拿!</p>
            <div>
                <div class="container">
                    <Carousel :wrapAround="true"  :autoplay="3500"  v-bind="settings" :breakpoints="breakpoints">
                        <Slide v-for="item in prizeList" :key="item.id">
                            <div class="carousel__item prizeList">
                                <div class="prize">
                                    <div class="prizeTag">{{ item.priceTag }}</div>
                                    <div class="prizePic">
                                        <img :src="item.priceImg" alt="">
                                    </div>
                                    <div class="prizeText">
                                        <p>{{ item.text }}</p>
                                        <p class="small">{{ ((item.count)) }}</p>
                                    </div>
                                </div>
                            </div>
                        </Slide>
                        <template #addons>
                            <pagination />
                        </template>
                    </Carousel>
                </div>
            </div>      
            </section>
            
            <section class="anotherIntro mb-50 pt-50" id="luckydrawcar">
                <div class="container">
                    <div class="introFrame">
                        <img src="../assets/bow.png" alt="" class="bow">
                        <div class="content">
                            <h3 class="titleBar">車險加碼獎</h3>
                            <p class="text">符合加碼獎任務者，即可獲得<span class="blue">立即抽</span> 抽獎機會!</p>
                            <div class="introList">
                                <h2>續保獎</h2>
                                <img src="../assets/plus01.svg" alt="" class="plusImg">
                                <p>經由網路投保專區續保入口完成投保，且該保單同時包含強制險與任意車險</p>
                            </div>
                            <div class="introList">
                                <h2>新保獎</h2>
                                <img src="../assets/plus02.svg" alt="" class="plusImg">
                                <p>過往未曾於網路投保專區投保之新戶，經由網路投保專區投保</p>
                            </div>
                            <div class="introList">
                                <h2>喬遷獎</h2>
                                <img src="../assets/plus03.svg" alt="" class="plusImg">
                                <p>前期車險保單非新安東京海上產險之保戶，經由網路投保專區，投保強制險。</p>
                            </div>

                        </div>
                    </div>
                </div>
                <p class="text mt-30">詳細活動規則請見下方說明</p>
            </section>
            <section class="anotherIntro mb-50" id="luckydrawmotor">
                <div class="container">
                    <div class="introFrame">
                        <img src="../assets/bow.png" alt="" class="bow">
                        <div class="content">
                            <h3 class="titleBar">機車強制險加碼獎</h3>
                            <div class="text" style="font-weight: bold">
                                <span class="mr-20"><span class="number">1</span>機車投保二年期強制險</span>
                                <span class="mr-20"><span class="number">2</span>同時勾選電子保單</span>
                               <span>即可獲得抽獎機會</span>
                            </div>
                            <div class="introList">
                                <img src="../assets/plus04.svg" alt="" class="plusImg">
                                <p>50名</p>
                            </div>

                        </div>
                    </div>
                </div>
                <p class="text mt-30">詳細活動規則請見下方說明</p>
            </section>
            <section class="introActivity py-50" id="luckydrawepolicy">
                <div class="container">
                    <div class="introFrame">
                        <img src="../assets/bow.png" alt="" class="bow">
                        <h3 class="titleBar">電子保單加碼獎</h3>
                        <div class="text" style="font-weight: bold">
                            <span><span class="number">1</span>符合大獎活動任務者</span>
                            <span><span class="number">2</span>同時勾選電子保單<span class="changeLine">即可獲得電子保單加碼獎抽獎機會<span class="blue">一次</span></span></span>
                        </div>
                    </div>
                </div>
                 <p class="text mt-30">詳細活動規則請見下方說明</p>
            </section>
        </div>
    </div>
</template>
<script setup>
import { reactive } from 'vue';
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide, Pagination } from 'vue3-carousel';
const presentList = reactive([
    {
        id:'present1',
        Icon: require("../assets/icon-car.svg"),
        title: "汽、機車險",
        text: "強制險＋任意險<br/>任意險＋電子保單",
        color:'listFrame1',
    },
    {
        id:'present2',
        Icon: require("../assets/icon-travel.svg"),
        title: "旅平險",
        text: "任一方案",
        content:null,
        color:'listFrame2',
    },
    {
        id:'present3',
        Icon: require("../assets/icon-house.svg"),
        title: "住火險",
        text: "任一方案＋電子保單",
        content:null,
        color:'listFrame3',
    },
    {
        id:'present4',
        Icon: require("../assets/icon-accident.svg"),
        title: "傷害險",
        text: "任一方案",
        content:null,
        color:'listFrame4',
    },
]);
const bigPrizeList = reactive([
    {
        id:'bigprize1',
        priceTag:'大獎',
        priceImg: require("../assets/gift-cruiseShip.svg"),
        text1: "歌詩達郵輪",
        text2: "沖繩自主行4天海景房雙人房",
        time:"第 三 季",
        count:"1 名",
    },
    {
        id:'bigprize2',
        priceTag:'電子保單A獎',
        priceImg: require("../assets/gift-oven.svg"),
        text1:"日本千石阿拉丁",
        text2:"遠紅外石墨大烤盤",
        time:"第 三 季",
        count:"1 名",
    },
    {
        id:'bigprize3',
        priceTag:'電子保單B獎',
        priceImg: require("../assets/gift-Switch2.svg"),
        text1: "Nintendo Switch 2",
        text2: "賽車世界 主機組合",
        time:"第 三 季",
        count:"1 名",
    },
    {
        id:'bigprize4',
        priceTag:'大獎',
        priceImg: require("../assets/gift-iphone.svg"),
        text1: "iPhone 18 Pro 256G",
        text2: "( 顏色隨機 )",
        time:"第 四 季",
        count:"1 名",
    },
    {
        id:'bigprize5',
        priceTag:'電子保單C獎',
        priceImg: require("../assets/gift-oven.svg"),
        text1:"日本千石阿拉丁",
        text2:"遠紅外石墨大烤盤",
        time:"第 四 季",
        count:"1 名",
    },
    {
        id:'bigprize6',
        priceTag:'電子保單D獎',
        priceImg: require("../assets/gift- IRIS OHYAMA.svg"),
        text1: "IRIS OHYAMA" ,
        text2: "乾燥循環除濕機(白)",
        time:"第 四 季",
        count:"1 名",
    }

]);
const prizeList = reactive([
    {
        id:'prize1',
        priceTag:'立即抽',
        priceImg: require("../assets/gift-300.svg"),
        text: "即享券 300 元(電子禮券)",
        count:"150名"
    },
    {
        id:'prize2',
        priceTag:'立即抽',
        priceImg: require("../assets/gift-100.svg"),
        text: "即享券 100 元(電子禮券)",
        count:"300名"
    },
    {
        id:'prize3',
        priceTag:'立即抽',
        priceImg: require("../assets/gift-25.svg"),
        text: "即享券 25 元(電子禮券)",
        count:"1,200名"
    },
    {
        id:'prize4',
        priceTag:'立即抽',
        priceImg: require("../assets/gift-8.svg"),
        text: "LINE POINTS 8 點",
        count:"2,400名"
    },
]);
const settings = {
    snapAlign: 'center',
};

const breakpoints = {
    325: {
        itemsToShow: 1,
        snapAlign: 'center',
    },
    767: {
        itemsToShow: 2,
        snapAlign: 'left',
    },
    1024: {
        itemsToShow: 3,
        snapAlign: 'left',
    },
};
</script>
<style lang="scss">
#present{

    text-align:center;
    #presentBg1{
        background: #FFECE3;
        border-bottom: 2px solid $black;
    }
    #presentBg2{
        background-color: #FFF7F4;
        background: url("../assets/bg-plus.svg") top center  repeat;
    }
    .list{
        display: flex;
        width:1024px;
        margin:auto;
        justify-content: space-around;
        p{
            height: 48px;
        }
        @media screen and (max-width: $nb) {
            width:90%;
            flex-wrap: wrap;
            justify-content: center;
        }
        .listFrame1,
        .listFrame2,
        .listFrame3,
        .listFrame4 {
            width: 240px;
            box-sizing: border-box;
            padding: 30px 20px;
            border: 2px solid $black;
            border-radius: 110px;
            font-size: 16px;

            h3 {
                color: $black;
                font-size: 20px;
                padding-bottom: 10px;
            }
        }

        .listFrame1 {
            background: linear-gradient(to bottom, #ecf2f0 0%, #ecf2f0 61%, $black 61.8%, $black 62%, #005bac 62%, #005bac 100%);
            padding: 30px 0;
            color: $white;
        }

        .listFrame2 {
            background: linear-gradient(to bottom, #ecf2f0 0%, #ecf2f0 61%, $black 61.8%, $black 62%, #ee5b6e 62%, #ee5b6e 100%);
            color: $white;
        }

        .listFrame3 {
            background: linear-gradient(to bottom, #ecf2f0 0%, #ecf2f0 61%, $black 61.8%, $black 62%, #ffbb78 62%, #ffbb78 100%);
        }

        .listFrame4 {
            background: linear-gradient(to bottom, #ecf2f0 0%, #ecf2f0 61%, $black 61.8%, $black 62%, $white 62%, $white 100%);
        }
        @media screen and (max-width: $nb) {
            width: 95%;
            .listFrame1, .listFrame2, .listFrame3, .listFrame4 {
                margin: 5px;
                width: calc(50% - 20px) !important;
            }
        }
    }

    .prizeList{
        display:flex;
        width:100%;
        justify-content: space-around;
        .prize{
            border:2px solid #4f4f4f;
            border-radius:20px;
            background-color:#fff;
            text-align: center;
            position:relative;
            margin:0 10px;
            width: 100%;
            .prizeTag{
                position:absolute;
                width:120px;
                height:64px;
                background:url(../assets/tag.svg);
                background-repeat: no-repeat;
                left:-10px;
                line-height: 36px;
                top:10px;
                font-weight:bold;
                color:#fff;
                background-size:contain;
                &.long{
                    text-align: left;
                    text-indent: 10px;
                }
            }
            .prizePic{
                width:90%;
                margin:15px auto 0;
                img{width:100%}
            }
            .prizeText{
                color:#4f4f4f;
                font-weight:bold;
                font-size:20px;
                padding:10px 0 20px;
                .small{font-size:16px;font-weight:400}
            }
        }
    }
    //.prizeBg2{
    //    background: url("../assets/slot-bg02.svg");
    //    background-repeat: no-repeat;
    //    background-position: left bottom;
    //    background-size:200px;
    //    width:1550px;
    //    margin:0 auto;
    //    @media screen and (max-width: 1550px) {
    //        background:transparent;
    //        width:100%;
    //    }
    //}
    .carousel{margin:0 0 85px;}
    .carousel__pagination{
        padding: 0;
        position: relative;
        top: 20px;
        z-index: 100;
        gap: 15px;
    }
    .carousel__pagination-button,.carousel__pagination-button::after{
        width:12px;
        height:12px;
        border-radius:12px;
        box-sizing: border-box;
        background:#e8e8e8;
    }
    .carousel__pagination-button--active,.carousel__pagination-button--active::after{
        background:$blue-700;
    }
    .introActivity{
        padding-top: 95px;
        .introFrame{
            position: relative;
            margin:0 auto 0;
            box-sizing: border-box;
            background:#fff;
            text-align: center;
            border-radius:20px;
            border:6px solid #E0713A;
            padding:20px 20px 50px 20px;
            .spImage{
                width: 350px;
            }
        }
        .spFrame{
            display: flex;
            width: 100%;
            position: relative;
            .spPic{
                padding: 20px 0;
            }
            .spAdd{
                position: absolute;
                top:50%;
                left:calc(30% + 6px);
                transform: translate(-50%, -50%);
            }

            .spBlueBox{
                width: 30%;
                margin: 10px;
                border-radius:20px;
                border:6px solid #4696A9;
                background: #F7FBFD;
                box-sizing: border-box;
                h2{
                    color: #ffff;
                    background: #4696A9;
                    font-size: 20px;
                    padding: calc(20px - 6px) 0;
                }
            }
            .spBox{
                width: 70%;
                margin: 10px;
                border-radius:20px;
                border:6px solid #E0713A;
                background: #FFF5D9;
                box-sizing: border-box;
                h2{
                    color: #ffff;
                    background: #E0713A;
                    font-size: 20px;
                    padding: calc(20px - 6px) 0;
                }
            }
            .spOrangeBox{
                display: flex;
                width: 100%;
            }

            @media screen and (max-width: $nb) {
                flex-wrap: wrap;
                .spBlueBox, .spBox{
                    width: 100%;
                    margin: 20px 10px ;
                }
                .spPic{
                    width: 33%;
                    margin: 0 auto;
                    img{
                        width: 80%;
                    }
                }
                .spAdd{
                    position: absolute;
                    top:calc(50% - 12px);
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
            }
            @media screen and (max-width: $mobile-large) {
                flex-wrap: wrap;
                .spBlueBox,.spBox{
                    width: 100%;
                }
                .spBlueBox{
                    height: 265px;
                }
                .spPic{
                    width: 80%;
                    margin: 0 auto;
                    padding: 20px ;
                    text-align: center;
                    img{
                        max-width: 265px;
                    }
                }
                .spOrangeBox{
                    display: block;
                }
                .spAdd{
                    position: absolute;
                    top:305px;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }

            }

        }
        .blueText{
            color:$blue-700;
            font-weight: bold;
            margin: 0;

        }
        .fontSize20 {font-size:20px;}
        .bow{margin-top:-80px;}
        p{
            margin:20px 0;
        }
        span{
            font-size: 16px;
            margin:0 10px;
            @media screen and (max-width: $pad) {
                margin: 0 auto 10px;
                //text-align: left;
                &.blue{display:inline}
            }
        }
        img{vertical-align: middle;margin:0 2px;}
    
        @media screen and (max-width: $mobile-small) {
            .introFrame>img{
                max-width:90%;
            }
            .introFrame {
                padding: 50px 10px ;
            }

            .bow{
                margin-top: -140px;
            }
        }
        .text16{font-size:16px; margin: 0 0 50px 0}
    }
    .number{
        background:#4f4f4f;
        border-radius: 100%;
        width:20px;
        height:20px;
        text-align: center;
        line-height:20px;
        color:#fff;
        display:inline-block;
        margin:0 5px;
        font-size:13px;
    }
    .anotherIntro{
        margin-top:95px;
        .introFrame{
            border-radius:20px;
            background:#fff;
            padding-bottom: 20px;
            border:6px solid #E0713A;
            .content{text-align: center;}
            .bow{
                margin-top:-50px ;
            }
            .introList{
                margin:20px 1%;
                vertical-align: top;
                display:inline-block;
                text-align: center;
                width:30%;
                box-sizing:border-box;
                padding:0 10px;
                font-size: 16px;
                h2{color:$blue-700;text-align: center;font-size:20px;}
                .plus{width:50px;display:inline;vertical-align: middle;margin-right:2px;}
                .plusImg{width:75%;display:inline-block;margin:10px auto;vertical-align: top;
                    &.noPlus{margin-top:25px;}
                }
                @media screen and (max-width: $mobile-small) {
                    width:90%;
                    margin:20px auto;
                    .plusImg{width:80%;display:block;margin:0 auto;
                        &.noPlus{margin-top:0;}
                    }
                }
            }
        }
        .text{font-size:16px;}
        .container+.text{
            text-align: center;
        }
    }
    .titleBar{
        background:$yellow-800;
        border:3px solid #4f4f4f;
        position:relative;
        border-radius: 50px;
        padding:5px 10px;
        text-align: center;
        color:#4f4f4f;
        max-width:300px;
        font-size:30px;
        margin:10px auto 20px;
        &:before{
            content:"";
            width:20px;
            height:20px;
            display:inline-block;
            background-image: url(../assets/title-flower.png);
            background-size:contain;
            background-repeat: no-repeat;
            position:absolute;
            left:8px;
            top:15px;
        }
        &:after{
            content:"";
            width:20px;
            height:20px;
            display:inline-block;
            background-image: url(../assets/title-flower.png);
            background-size:contain;
            background-repeat: no-repeat;
            position:absolute;
            right:8px;
            top:15px;
        }
        @media screen and (max-width: $mobile-small) {
            width:80%;
            font-size: 24px;
        }
    }
    span.blue{
        background:$blue-700;
        color:#fff;
        padding:3px 10px;
        border-radius:100px;
        box-sizing: border-box;
        margin:0 5px;
    }
    .subText{
        color: $gray-600;
    }
}

</style>
